import { Stack } from "@mui/material";
import PaymentsTable from "../tables/PaymentsTable";
import PaymentsFilter from "../filters/PaymentsFilter";

function Payments() {

    return (
            <Stack direction={"column"} spacing={2} margin={"16px"}>
                <PaymentsFilter/>
                <PaymentsTable/>
            </Stack>
    );
}

export default Payments;